import { CUSTOM_ELEMENTS_SCHEMA, NgModule, inject, provideAppInitializer } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { HeaderModule } from './components/header/header.module';
import { RootcategoriesModule } from './components/rootcategories/rootcategories.module';
import { SubcategoriesModule } from './components/subcategory/subcategory.module';
import { ChildcategoriesModule } from './components/childcategory/childcategory.module';
import { PointsOfInterestModule } from './components/points-of-interest/points-of-interest.module';
import { PoiProfileModule } from './components/poi-profile/poi-profile.module';
import { MainMenuModule } from './components/main-menu/main-menu.module';
import { HomeComponent } from './home/home.component';
import { AppComponent } from './app.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { HeaderComponent } from './components/header/header.component';
import { ErrorPageComponent } from './shared/error-page/error-page.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatSliderModule } from '@angular/material/slider';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDividerModule } from '@angular/material/divider';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { RouterModule } from '@angular/router';
import { NodeService } from './services/node-service/node-service.service';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { AddCategoryComponent } from './components/add-category/add-category.component';
import { ViewAddParentComponent } from './components/view-add-parent/view-add-parent.component';
import { ViewAddCategoryComponent } from './components/view-add-category/view-add-category.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ViewAddSubcategoryComponent } from './components/view-add-subcategory/view-add-subcategory.component';
import { ViewAddPoisComponent } from './components/view-add-pois/view-add-pois.component';
import { AddPoiComponent } from './components/add-poi/add-poi.component';
import { EditRootcategoryComponent } from './components/edit-rootcategory/edit-rootcategory.component';
import { EditCategoryComponent } from './components/edit-category-view/edit-category.component';
import { EditSubcategoryComponent } from './components/edit-subcategory/edit-subcategory.component';
import { EditPoiViewComponent } from './components/edit-poi-view/edit-poi-view.component';
import { JwtInterceptor } from './_helpers/jwt.interceptor';
import { LocalApiProxyInterceptor } from './_helpers/local-api-proxy.interceptor';
import { MatTreeModule } from '@angular/material/tree';
import { MatListModule } from '@angular/material/list';
import { MatDialogModule } from '@angular/material/dialog';
import { DialogComponent } from './components/dialog/dialog.component';
import { SelectComponent } from './components/select/select.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { DeleteConfirmComponent } from './components/delete-confirm/delete-confirm.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { APP_BASE_HREF } from '@angular/common';
import { DatePipe } from '@angular/common';
import { MassDeleteComponent } from './components/dialog-mass-delete/mass-delete.component';
import { DialogLogsComponent } from './components/dialog-logs/dialog-logs.component';
import { AppConfigService } from './auth/services/app-config.service';
import { providePrimeNG } from 'primeng/config';
import Lara from '@primeng/themes/lara';
import { provideAuth, StsConfigLoader } from 'angular-auth-oidc-client';
import { httpLoaderFactoryFn } from './auth/config/auth-config.loader';

@NgModule({
  declarations: [
    AppComponent,
    BreadcrumbComponent,
    HomeComponent,
    HeaderComponent,
    ErrorPageComponent,
    AddCategoryComponent,
    ViewAddParentComponent,
    ViewAddCategoryComponent,
    ViewAddSubcategoryComponent,
    ViewAddPoisComponent,
    AddPoiComponent,
    EditRootcategoryComponent,
    EditCategoryComponent,
    EditSubcategoryComponent,
    EditPoiViewComponent,
    DialogComponent,
    DeleteConfirmComponent,
    MassDeleteComponent,
    DialogLogsComponent,
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HeaderModule,
    BrowserAnimationsModule,
    MatSliderModule,
    MainMenuModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatIconModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatToolbarModule,
    MatTooltipModule,
    RootcategoriesModule,
    BreadcrumbModule,
    MatDividerModule,
    MatListModule,
    SubcategoriesModule,
    ChildcategoriesModule,
    PointsOfInterestModule,
    MatGridListModule,
    PoiProfileModule,
    MatSnackBarModule,
    MatCardModule,
    ReactiveFormsModule,
    RouterModule,
    /* S */
    SelectComponent,
    MatDialogModule,
    MatTreeModule,
    MatCheckboxModule,
    MatRadioModule,
    GoogleMapsModule,
  ],
  providers: [
    AppConfigService,
    NodeService,
    DatePipe,
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LocalApiProxyInterceptor, multi: true },
    provideHttpClient(withInterceptorsFromDi()),
    provideAppInitializer(() => {
      const initializerFn = ((appConfig: AppConfigService) => {
        return () => appConfig.loadConfig();
      })(inject(AppConfigService));
      return initializerFn();
    }),
    {
      provide: APP_BASE_HREF,
      useFactory: (appConfig: AppConfigService) => {
        return appConfig.config ? appConfig.config.baseHref : '/';
      },
      deps: [AppConfigService],
    },
    providePrimeNG({
      theme: {
        preset: Lara,
      },
    }),
    provideAuth({
      loader: {
        provide: StsConfigLoader,
        useFactory: httpLoaderFactoryFn,
        deps: [AppConfigService],
      },
    }),
  ],
})
export class AppModule {}

























